/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @typescript-eslint/no-loop-func */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-restricted-syntax */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
import React, { FC, useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Form,
  Multistep,
  ArrayField,
  useFormState,
  useFormApi,
  useMultistepApi,
  FormState,
} from 'informed';
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import { toast } from 'react-toastify';
import { Button } from '@ui-modules';
import { useAuth } from '@ui-modules/auth';
import { Loader } from '@components';
import { DRIVE_EDITABLE_STATUS, TRIP_TYPES, TRANSFER_TYPES } from '@common/constants';
import { Add, CloseRound } from '@assets/svg/icons';
import { useNonSpammyFieldState } from '@common/hooks';
import { IDropdownOption } from '@ui-modules/types';
import {
  DriveFormData,
  FacilityDriver,
  FacilityVehicle,
  IChoice,
  IWindowWithScheduler,
  MappedDrive,
  MultiSteps,
} from '@common/interfaces';

import {
  DriverField,
  DropOffDateField,
  DropOffDateReturnField,
  DropOffLocationField,
  DropOffTimeField,
  DropOffTimeReturnField,
  DropOffTownField,
  GuestAgencyField,
  GuestAgencyNameField,
  GuestEmailField,
  GuestNameField,
  GuestPhoneNumberField,
  GuestSurnameField,
  IndexNumberField,
  ManagerEmailField,
  NoPassengersField,
  PassengersNumberField,
  PickupDateField,
  PickupDateReturnField,
  PickupLocationField,
  PickupTimeField,
  PickupTimeReturnField,
  PickupTownField,
  PurposeField,
  RecurringDrive,
  RemarksField,
  RequestUnitField,
  TransferTypeField,
  TripTypeField,
  VehicleKeyField,
} from './fields';
import {
  calculateSharedDrive,
  checkConflictingDrivesOnPlanner,
  checkOverlappingDrives,
  getSoonTime,
} from '../../../../utils';
import css from './styles.module.scss';

const moment = extendMoment(Moment as any);

// Config
const TIME_INTERVAL = 15;
const MIN_PASSENGER_CAPACITY = 1;
const DEFAULT_MAX_PASSENGER_CAPACITY = 4;

const defaultDrive = {
  booked_route_order: 1,
  booking: {
    transfer_type: '',
    type_of_trip: '',
  },
  driver: null,
  dropoff_date: '',
  dropoff_location: '',
  dropoff_time: '',
  dropoff_town: '',
  is_temporary: true,
  pickup_date: '',
  pickup_location: '',
  pickup_time: '',
  pickup_town: '',
  price_category: 'generic',
  vehicle: null,
  is_hide: true,
  editable_state: '',
  // TO DO: Should be delete
  start_date: new Date(),
  end_date: new Date(),
};

interface IEditForm {
  formRef: React.RefObject<HTMLDivElement>;
  formData: any; // MappedDrive
  handleSave: (values: DriveFormData) => void;
  handleCancel: () => void;
  drivers: FacilityDriver[];
  vehicles: FacilityVehicle[];
  drives: MappedDrive[];
  city: string;
  currentDate?: string;
  purposes: IChoice[];
  requestingUnits: IChoice[];
  agencyId: number;
  agencyName: string;
  locationId: number;
}

const tripTypeOptions = [
  { value: TRIP_TYPES.ONE_WAY, label: 'One way' },
  { value: TRIP_TYPES.ROUND_TRIP, label: 'Round trip' },
  { value: TRIP_TYPES.MULTI_LEG, label: 'Multi leg' },
];

const processFormData = (formData: FormState, isEdit: boolean) => {
  const transfer_type = isEdit
    ? formData.values.trip_info.transfer_type
    : formData.values.transfer_type;

  const driveData = {
    ...formData.values,
    ...formData.values.main_info,
    ...formData.values.trip_info,
    ...formData.values.return_trip,
    transfer_type,
  };

  return driveData;
};

let multiLegsRendered = 0;

const EditForm: FC<IEditForm> = ({
  agencyId,
  agencyName,
  currentDate,
  city,
  drivers,
  drives,
  formData,
  formRef,
  handleCancel,
  handleSave,
  locationId,
  purposes,
  requestingUnits,
  vehicles,
}) => {
  const { t } = useTranslation();
  const { axios } = useAuth();

  const [drive, setDrive] = useState(defaultDrive);
  const [loading, setLoading] = useState(false);

  const {
    booked_route_order,
    booking: {
      agency,
      agency_fk,
      agency_short_name,
      transfer_type,
      type_of_trip,
      email,
      first_name,
      index_number,
      last_name,
      manager_email,
      n_of_passengers,
      phone_number,
      purpose,
      remarks,
      requesting_unit,
      is_third_party,
    },
    driver,
    dropoff_location,
    dropoff_town,
    has_passengers,
    pickup_location,
    pickup_town,
    vehicle,
    editable_state,
    uuid,
  } = drive;

  const vehicle_id = vehicle || formData.vehicle_id;

  const { start_date, end_date } = formData;

  const { scheduler } = window as unknown as IWindowWithScheduler;
  const { new_event } = scheduler.getState();

  const isEdit = new_event === null;

  const currentDriver = drivers.find((d: FacilityDriver) => d.driver_identifier === driver);
  const currentVehicle = vehicles.find(
    (v: FacilityVehicle) => v.vehicle_identifier === parseFloat(vehicle_id),
  );

  // TO DO: Delete deprecated frontend logic after merging
  const isEditForbidden = editable_state === DRIVE_EDITABLE_STATUS.GREY;

  const vehicleMaxCapacity = currentVehicle
    ? currentVehicle.max_capacity
    : DEFAULT_MAX_PASSENGER_CAPACITY;
  const paxOptions: IDropdownOption[] = [];
  for (let count = MIN_PASSENGER_CAPACITY; count <= vehicleMaxCapacity; count += 1) {
    paxOptions.push({ label: count.toString(), value: count.toString() });
  }

  const purposeOptions = purposes.map(({ value, display_name }) => ({
    value,
    label: display_name,
  }));

  const unitOptions = requestingUnits.map(({ value, display_name }) => ({
    value,
    label: display_name,
  }));

  const availableDrivers = drivers.filter((d: FacilityDriver) => {
    const driverEvents = drives
      .filter((drive: MappedDrive) => drive.driver === d.driver_identifier)
      .filter((drive: MappedDrive) => {
        const range_unavailable = moment.range(drive.start_date, drive.end_date);
        const range_selected = moment.range(start_date, end_date);

        return range_unavailable.overlaps(range_selected);
      });
    return driverEvents.length === 0;
  });

  if (isEdit && currentDriver) {
    availableDrivers.push(currentDriver);
  }

  const driversOptions = availableDrivers.map(
    ({ driver_identifier, last_name, name }: FacilityDriver): IDropdownOption => ({
      label: `${name} ${last_name}`,
      value: driver_identifier?.toString(),
    }),
  );

  const driversOptionsFull = drivers.map(
    ({ driver_identifier, last_name, name }: FacilityDriver): IDropdownOption => ({
      label: `${name} ${last_name}`,
      value: driver_identifier?.toString(),
    }),
  );

  const vehiclesOptions = vehicles
    .filter((vehicle) => !vehicle.is_disabled)
    .map(
      ({ label, vehicle_identifier }: FacilityVehicle): IDropdownOption => ({
        label,
        value: vehicle_identifier.toString(),
      }),
    );

  const initialVehicleValue = vehiclesOptions.find((i) => i.value === vehicle_id);

  // TO DO: Should be deleted
  const {
    dropoff_date: dropoff_date_return = '',
    dropoff_location: dropoff_location_return = '',
    dropoff_time: dropoff_time_return = '',
    dropoff_town: dropoff_town_return = '',
    pickup_date: pickup_date_return = '',
    pickup_location: pickup_location_return = '',
    pickup_time: pickup_time_return = '',
    pickup_town: pickup_town_return = '',
  } = {};

  const multilegInitialValue = {
    pickup_date: start_date,
    pickup_time: start_date,
    dropoff_date: end_date,
    dropoff_time: end_date,
    pickup_town: isEdit ? drive.pickup_town : city,
    pickup_location: drive.pickup_location ?? '',
    dropoff_town: isEdit ? drive.pickup_town : city,
    dropoff_location: drive.dropoff_location ?? '',
    vehicle: initialVehicleValue,
    driver: driversOptions.find((i) => i.value === driver),
  };

  const initialValues: any = {
    main_info: {
      agency: { label: agency_short_name, value: agency_fk },
      agency_name: agency,
      first_name,
      email,
      index_number,
      last_name,
      manager_email,
      n_of_passengers: paxOptions.find((i) => +i.value === n_of_passengers),
      no_passengers: isEdit ? !has_passengers : false,
      phone_number,
      remarks,
      requesting_unit: unitOptions.find((i) => i.value === requesting_unit),
    },
    trip_info: {
      transfer_type,
      vehicle: initialVehicleValue,
      type_of_trip: tripTypeOptions.find((i) => i.value === type_of_trip),
      driver: driversOptions.find((i) => i.value === driver),
      pickup_date: start_date,
      pickup_location,
      pickup_time: isEdit ? start_date : getSoonTime(start_date),
      pickup_town: isEdit ? pickup_town : city,
      dropoff_location,
      dropoff_date: end_date,
      dropoff_time: isEdit
        ? end_date
        : moment(getSoonTime(start_date)).add(TIME_INTERVAL, 'minutes').toDate(),
      dropoff_town: isEdit ? dropoff_town : transfer_type === TRANSFER_TYPES.OUT_TOWN ? '' : city,
      purpose: purposeOptions.find((i) => i.value === purpose),
      drives: isEdit ? [multilegInitialValue] : [multilegInitialValue, multilegInitialValue],
    },
    return_trip: {
      driver_return: driversOptions.find((i) => i.value === driver),
      dropoff_date_return: isEdit ? moment(dropoff_date_return, 'YYYY-MM-DD').toDate() : end_date,
      dropoff_location_return,
      dropoff_time_return: isEdit
        ? moment(dropoff_time_return, 'HH:mm:ss').toDate()
        : moment(getSoonTime(start_date)).add(TIME_INTERVAL, 'minutes').toDate(),
      dropoff_town_return: isEdit
        ? dropoff_town_return
        : transfer_type === TRANSFER_TYPES.OUT_TOWN
        ? ''
        : city,
      pickup_date_return: isEdit ? moment(pickup_date_return, 'YYYY-MM-DD').toDate() : start_date,
      pickup_location_return,
      pickup_time_return: isEdit
        ? moment(pickup_time_return, 'HH:mm:ss').toDate()
        : getSoonTime(start_date),
      pickup_town_return: isEdit ? pickup_town_return : city,
      vehicle_return: initialVehicleValue,
    },
  };

  const title = !isEdit
    ? t('planner.createDrive')
    : isEditForbidden
    ? t('planner.driveReadOnly')
    : t('common.editDrive');

  const ButtonSubmit: FC = () => (
    <div className={css.hint}>
      {isEditForbidden && <div>{t('planner.justReadOnly')}</div>}
      <Button
        data-testid="mobility-planner-edit-form-save"
        disabled={isEditForbidden}
        text={t('common.btnSave')}
        type="submit"
        variant="primary"
      />
    </div>
  );

  const getDrive = async (): Promise<void> => {
    setLoading(true);

    const query = new URLSearchParams({
      agency_id: agencyId?.toString(),
    });

    try {
      const response = await axios.get(
        `/facilities/${locationId}/planner/drives/${formData.id}/?${query}`,
      );

      const result = response?.data;

      if (result) {
        setDrive(result);
      }
    } catch (error) {
      console.log(error);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (formData.id) {
      getDrive();
    }
  }, []);

  const MainInfoStep: FC = () => {
    const formApi = useFormApi();
    const { values } = useFormState() as any;
    const { next, setCurrent } = useMultistepApi();

    const thirdPartyAgencySelected = useMemo(() => {
      if (values?.agenciesOptions?.length === 1) {
        const [agencyValue] = values.agenciesOptions;
        return agencyValue.isThirdParty;
      }

      if (isEdit && is_third_party) return true;
      return false;
    }, [values?.agenciesOptions]);

    useEffect(() => {
      formApi.setValue(`${MultiSteps.MainInfo}.third_party`, thirdPartyAgencySelected);
    }, [thirdPartyAgencySelected]);

    return (
      <Multistep.Step step={MultiSteps.MainInfo} next={MultiSteps.TripInfo}>
        {isEdit && (
          <div className={css.paginator}>
            <Button
              className={css.button}
              data-testid="mobility-planner-edit-form-main-info"
              disabled
              text={t('planner.mainInfo')}
              onClick={() => setCurrent(MultiSteps.MainInfo)}
            />
            <Button
              data-testid="mobility-planner-edit-form-trip-info"
              className={css.button}
              text={t('planner.tripInfo')}
              onClick={() => setCurrent(MultiSteps.TripInfo)}
            />
          </div>
        )}
        <div className={css.formset}>
          <div className={css.wrap}>
            <div className={css.column}>
              <GuestNameField />
              <GuestSurnameField />
              <GuestEmailField />
              <GuestPhoneNumberField />
              <PassengersNumberField paxOptions={paxOptions} />
            </div>
            <div className={css.column}>
              <GuestAgencyField agencyId={agencyId} agencyName={agencyName} />
              {thirdPartyAgencySelected ? <GuestAgencyNameField /> : null}
              <IndexNumberField />
              <RequestUnitField unitOptions={unitOptions} />
              <ManagerEmailField />
              <NoPassengersField
                isEdit={isEdit}
                paxOptions={paxOptions}
                n_of_passengers={n_of_passengers}
              />
            </div>
          </div>
          <RemarksField />
          <div className={css.buttons}>
            <Button
              text={t('common.btnCancel')}
              variant="secondary"
              onClick={handleCancel}
              data-testid="mobility-planner-edit-form-cancel"
            />
            <Button
              text={t('common.btnNext')}
              variant="submit"
              onClick={next}
              data-testid="mobility-planner-edit-form-next"
            />
          </div>
        </div>
      </Multistep.Step>
    );
  };

  const TripInfoStep: FC = () => {
    const { next, setCurrent } = useMultistepApi();
    const formApi = useFormApi();

    const multistepName = MultiSteps.TripInfo;

    const { value: transfer_type } = useNonSpammyFieldState(
      isEdit ? `${multistepName}.transfer_type` : 'transfer_type',
    );
    const { value: type_of_trip } = useNonSpammyFieldState(`${multistepName}.type_of_trip`);

    const isMultiLegEnabled = true;

    const isRoundTrip = type_of_trip?.value === TRIP_TYPES.ROUND_TRIP;
    const isMultiLeg =
      isMultiLegEnabled &&
      type_of_trip?.value === TRIP_TYPES.MULTI_LEG &&
      transfer_type !== TRANSFER_TYPES.FROM_TO_AIRPORT;

    const { values } = useFormState();

    const dropoff_date = values?.[multistepName]?.dropoff_date;
    const dropoff_time = values?.[multistepName]?.dropoff_time;
    const pickup_date = values?.[multistepName]?.pickup_date;
    const pickup_time = values?.[multistepName]?.pickup_time;
    const vehicle = values?.[multistepName]?.vehicle;

    const updatedTripTypes = isMultiLegEnabled
      ? tripTypeOptions
      : tripTypeOptions.filter((option) => option.value !== TRIP_TYPES.MULTI_LEG);

    const sharedDrive = calculateSharedDrive({
      dropoff_date,
      dropoff_time,
      pickup_date,
      pickup_time,
      vehicle,
      drives,
    });

    let nextButton = null;
    if (transfer_type) {
      if (!isEdit) {
        if (isRoundTrip) {
          nextButton = (
            <Button
              text={t('common.btnNext')}
              variant="submit"
              onClick={next}
              data-testid="mobility-planner-edit-form-next"
            />
          );
        } else if (!isRoundTrip && sharedDrive) {
          nextButton = (
            <Button
              text={t('common.btnSave')}
              variant="primary"
              onClick={next}
              data-testid="mobility-planner-edit-form-save"
            />
          );
        } else {
          nextButton = <ButtonSubmit />;
        }
      } else {
        nextButton = <ButtonSubmit />;
      }
    }

    const stepTitle = isRoundTrip
      ? isEdit
        ? booked_route_order === 1
          ? 'Outward Trip'
          : 'Return Trip'
        : '1. Outward Trip'
      : null;

    const getFieldsSection = (): JSX.Element => {
      let fieldsSection: JSX.Element;

      if (!isMultiLeg) {
        fieldsSection = (
          <>
            {stepTitle && <div className={css.steptitle}>{stepTitle}</div>}
            <div className={css.wrap}>
              <div className={css.column}>
                <PickupDateField />
                <PickupTownField />
                <DropOffDateField />
                <DropOffTownField />
                <VehicleKeyField vehiclesOptions={vehiclesOptions} />
              </div>
              <div className={css.column}>
                <PickupTimeField />
                <PickupLocationField />
                <DropOffTimeField />
                <DropOffLocationField />
                <DriverField
                  driver={driver}
                  driversOptions={driversOptions}
                  driversOptionsFull={driversOptionsFull}
                  isEdit={isEdit}
                  sharedDrive={!isEdit ? sharedDrive : null}
                  vehicles={vehicles}
                />
              </div>
            </div>
          </>
        );
      } else {
        fieldsSection = (
          <ArrayField name="drives">
            {({ addWithInitialValue }) => (
              <>
                <ArrayField.Items>
                  {({ name, remove, index }) => {
                    multiLegsRendered = index + 2;

                    return (
                      <div className={css.multileg} key={name}>
                        <h4 className={css.multileg__heading}>
                          Leg {isEdit ? booked_route_order : index + 1}
                          {index > 1 && !isEdit && (
                            <div className={css.multileg__remove} onClick={remove}>
                              &#215;
                            </div>
                          )}
                        </h4>
                        <div className={css.multileg__fields}>
                          <PickupDateField />
                          <PickupTimeField />
                          <PickupTownField multilegField={name} />
                          <PickupLocationField multilegField={name} />
                          <DropOffDateField />
                          <DropOffTimeField />
                          <DropOffTownField multilegField={name} />
                          <DropOffLocationField multilegField={name} />
                          <VehicleKeyField vehiclesOptions={vehiclesOptions} />
                          <DriverField
                            driver={driver}
                            driversOptions={driversOptions}
                            driversOptionsFull={driversOptionsFull}
                            isEdit={isEdit}
                            sharedDrive={!isEdit ? sharedDrive : null}
                            vehicles={vehicles}
                          />
                        </div>
                      </div>
                    );
                  }}
                </ArrayField.Items>
                {multiLegsRendered < 5 && !isEdit && (
                  <Button
                    className={css.multileg__add}
                    icon={<Add />}
                    text={t('planner.addLeg')}
                    variant="primary"
                    onClick={() => addWithInitialValue(multilegInitialValue)}
                  />
                )}
              </>
            )}
          </ArrayField>
        );
      }

      return fieldsSection;
    };

    return (
      <Multistep.Step
        step={MultiSteps.TripInfo}
        previous={MultiSteps.MainInfo}
        next={MultiSteps.ReturnTrip}
      >
        {isEdit && (
          <div className={css.paginator}>
            <Button
              data-testid="mobility-planner-edit-form-main-info"
              className={css.button}
              text={t('planner.mainInfo')}
              onClick={() => setCurrent(MultiSteps.MainInfo)}
            />
            <Button
              className={css.button}
              data-testid="mobility-planner-edit-form-trip-info"
              disabled
              text={t('planner.tripInfo')}
              onClick={() => setCurrent(MultiSteps.TripInfo)}
            />
          </div>
        )}
        <div className={css.formset}>
          <TransferTypeField city={city} isEdit={isEdit} />
          {transfer_type ? (
            <>
              {transfer_type !== TRANSFER_TYPES.FROM_TO_AIRPORT ? (
                <TripTypeField tripTypeOptions={updatedTripTypes} isEdit={isEdit} />
              ) : null}
              {type_of_trip || transfer_type === TRANSFER_TYPES.FROM_TO_AIRPORT ? (
                <>
                  {getFieldsSection()}
                  {transfer_type !== TRANSFER_TYPES.FROM_TO_AIRPORT ? (
                    <PurposeField purposeOptions={purposeOptions} />
                  ) : null}
                  {values.addingRecurring && type_of_trip?.value !== TRIP_TYPES.ROUND_TRIP ? (
                    <RecurringDrive
                      currentStep={MultiSteps.TripInfo}
                      multiLeg={isMultiLeg}
                      currentDate={currentDate}
                    />
                  ) : null}
                </>
              ) : null}
              <div className={css.buttons}>
                <Button
                  data-testid="mobility-planner-edit-form-back"
                  text={t('common.btnBack')}
                  variant="secondary"
                  onClick={() => setCurrent(MultiSteps.MainInfo)}
                />
                {(transfer_type === TRANSFER_TYPES.FROM_TO_AIRPORT ||
                  (type_of_trip && type_of_trip?.value !== TRIP_TYPES.ROUND_TRIP)) &&
                !isEdit ? (
                  values.addingRecurring ? (
                    <Button
                      onClick={() => formApi.setValue('addingRecurring', false)}
                      text={t('common.recurring.cancelRecurringBtn')}
                      variant="primary"
                    />
                  ) : (
                    <Button
                      onClick={() => formApi.setValue('addingRecurring', true)}
                      text={t('common.recurring.addRecurringBtn')}
                      variant="primary"
                    />
                  )
                ) : null}
                {nextButton}
              </div>
            </>
          ) : null}
        </div>
      </Multistep.Step>
    );
  };

  const ReturnTripStep: FC = () => {
    const { previous, next, setCurrent } = useMultistepApi();
    const formApi = useFormApi();
    const { values } = useFormState();

    const dropoff_date_return = values?.return_trip?.dropoff_date_return;
    const dropoff_time_return = values?.return_trip?.dropoff_time_return;
    const pickup_date_return = values?.return_trip?.pickup_date_return;
    const pickup_time_return = values?.return_trip?.pickup_time_return;
    const vehicle_return = values?.return_trip?.vehicle_return;

    const sharedDrive =
      dropoff_date_return &&
      dropoff_time_return &&
      pickup_date_return &&
      pickup_time_return &&
      vehicle_return
        ? calculateSharedDrive({
            dropoff_date: dropoff_date_return,
            dropoff_time: dropoff_time_return,
            pickup_date: pickup_date_return,
            pickup_time: pickup_time_return,
            vehicle: vehicle_return,
            drives,
          })
        : null;

    return (
      <Multistep.Step
        step={MultiSteps.ReturnTrip}
        previous={MultiSteps.TripInfo}
        next={sharedDrive ? MultiSteps.ApprovingSharedDrive : undefined}
        relevant={({ formState }) => {
          const tripInfo = formState.values?.trip_info;

          if (tripInfo) {
            const { type_of_trip } = tripInfo;

            if (type_of_trip?.value !== TRIP_TYPES.ROUND_TRIP) {
              return false;
            }
          }

          return true;
        }}
      >
        {isEdit && (
          <div className={css.paginator}>
            <Button
              className={css.button}
              text={t('common.info')}
              onClick={() => setCurrent(MultiSteps.MainInfo)}
              data-testid="mobility-planner-edit-form-main-info"
            />
            <Button
              className={css.button}
              text={t('common.info')}
              onClick={() => setCurrent(MultiSteps.TripInfo)}
              data-testid="mobility-planner-edit-form-trip-info"
            />
          </div>
        )}
        <div className={css.formset}>
          <div className={css.steptitle}>2. {t('planner.returnTrip')}</div>
          <div className={css.wrap}>
            <div className={css.column}>
              <PickupDateReturnField />
              <PickupTownField returnTrip />
              <DropOffDateReturnField />
              <DropOffTownField returnTrip />
              <VehicleKeyField returnTrip vehiclesOptions={vehiclesOptions} />
            </div>
            <div className={css.column}>
              <PickupTimeReturnField />
              <PickupLocationField returnTrip />
              <DropOffTimeReturnField />
              <DropOffLocationField returnTrip />
              <DriverField
                driversOptions={driversOptions}
                driversOptionsFull={driversOptionsFull}
                driver={driver}
                isEdit={isEdit}
                sharedDrive={!isEdit ? sharedDrive : null}
                vehicles={vehicles}
                returnTrip
              />
            </div>
          </div>
          {values.addingRecurring ? (
            <RecurringDrive currentStep={MultiSteps.ReturnTrip} currentDate={currentDate} />
          ) : null}
          <div className={css.buttons}>
            <Button
              text={t('common.btnBack')}
              variant="secondary"
              onClick={previous}
              data-testid="mobility-planner-edit-form-back"
            />
            {values.addingRecurring ? (
              <Button
                onClick={() => formApi.setValue('addingRecurring', false)}
                text={t('common.recurring.cancelRecurringBtn')}
                variant="primary"
              />
            ) : (
              <Button
                text={t('common.recurring.addRecurring')}
                variant="primary"
                onClick={() => formApi.setValue('addingRecurring', true)}
              />
            )}
            {sharedDrive ? (
              <Button
                text={t('common.btnSave')}
                variant="primary"
                onClick={next}
                data-testid="mobility-planner-edit-form-save"
              />
            ) : (
              <ButtonSubmit />
            )}
          </div>
        </div>
      </Multistep.Step>
    );
  };

  const ApprovingSharedDriveStep: FC = () => {
    const { next } = useMultistepApi();
    const { values } = useFormState();
    const isRoundTrip = values.type_of_trip?.value === TRIP_TYPES.ROUND_TRIP;

    const isReturnTripInfoFilled =
      values.pickup_date_return &&
      values.dropoff_date_return &&
      values.pickup_location_return &&
      values.dropoff_location_return;

    let nextButton: JSX.Element | null = null;
    let nextStep: string | undefined;

    if (isRoundTrip) {
      if (isReturnTripInfoFilled) {
        nextStep = undefined;
        nextButton = (
          <Button
            text={t('common.yes')}
            type="submit"
            variant="submit"
            data-testid="mobility-planner-edit-form-approving-shared-driver-yes"
          />
        );
      } else {
        nextStep = 'return-trip';
        nextButton = (
          <Button
            text={t('common.yes')}
            variant="submit"
            onClick={next}
            data-testid="mobility-planner-edit-form-approving-shared-driver-yes"
          />
        );
      }
    } else {
      nextStep = undefined;
      nextButton = (
        <Button
          text={t('common.yes')}
          type="submit"
          variant="submit"
          data-testid="mobility-planner-edit-form-approving-shared-driver-yes"
        />
      );
    }

    return (
      <Multistep.Step step={MultiSteps.ApprovingSharedDrive} next={nextStep}>
        <div
          className={css.formset}
          data-testid="mobility-planner-edit-form-approving-shared-driver"
        >
          <div className={css.warning}>
            <p>{t('planner.multiWarn1')}.</p>
            <p>
              {t('common.click')} <b>{t('common.yes')}</b> {t('planner.multiWarn2')}{' '}
              {t('common.click')} <b>{t('common.no')}</b> {t('planner.multiWarn3')}.
            </p>
          </div>
          <div className={css.buttons}>
            <Button
              text={t('common.no')}
              variant="danger"
              onClick={handleCancel}
              data-testid="mobility-planner-edit-form-approving-shared-driver-no"
            />
            {nextButton}
          </div>
        </div>
      </Multistep.Step>
    );
  };

  const processSubmit = (formData: FormState): void => {
    const driveData = processFormData(formData, isEdit);
    const { type_of_trip, drives: submittedDrives, addingRecurring } = driveData;

    if (submittedDrives?.length && checkOverlappingDrives(submittedDrives)) {
      toast.error(t('planner.messageOverlappingDrives'));
      return;
    }

    if (!addingRecurring) {
      if (type_of_trip?.value === TRIP_TYPES.MULTI_LEG) {
        for (const drive of submittedDrives) {
          const sharedDrive = calculateSharedDrive({
            pickup_date: drive.pickup_date,
            pickup_time: drive.pickup_time,
            dropoff_date: drive.dropoff_date,
            dropoff_time: drive.dropoff_time,
            vehicle: drive.vehicle,
            driver: drive.driver,
            drives: drives.filter((drive) => drive.uuid !== uuid),
          });

          if (sharedDrive) {
            toast.error(t('planner.messageSharedDrive'));
            return;
          }
        }
      } else {
        let isConflicting = checkConflictingDrivesOnPlanner({
          pickup_date: driveData.pickup_date,
          pickup_time: driveData.pickup_time,
          dropoff_date: driveData.dropoff_date,
          dropoff_time: driveData.dropoff_time,
          vehicle: driveData.vehicle,
          driver: driveData.driver,
          drives: drives.filter((drive) => drive.uuid !== uuid),
        });

        const isRoundTrip = type_of_trip?.value === TRIP_TYPES.ROUND_TRIP;

        if (isRoundTrip && !isConflicting && !isEdit) {
          isConflicting = checkConflictingDrivesOnPlanner({
            pickup_date: driveData.pickup_date_return!,
            pickup_time: driveData.pickup_time_return!,
            dropoff_date: driveData.dropoff_date_return!,
            dropoff_time: driveData.dropoff_time_return!,
            vehicle: driveData.vehicle_return!,
            driver: driveData.driver_return,
            drives: drives.filter((drive) => drive.uuid !== uuid),
          });
        }

        if (isConflicting) {
          toast.error(t('planner.messageConflictingDrives'));
          return;
        }
      }
    }

    handleSave({ ...driveData, uuid });
  };

  return (
    <div ref={formRef} className={css.popup}>
      <div className={css.title} data-testid="mobility-planner-edit-form-title">
        {title}
        <Button
          variant="icon"
          onClick={handleCancel}
          icon={<CloseRound className={css.close} data-testid="common-close-round-icon" />}
        />
      </div>
      {loading ? (
        <Loader />
      ) : (
        <Form className={css.form} initialValues={initialValues} onSubmit={processSubmit}>
          <Multistep initialStep={MultiSteps.MainInfo}>
            <MainInfoStep />
            <TripInfoStep />
            <ReturnTripStep />
            <ApprovingSharedDriveStep />
          </Multistep>
        </Form>
      )}
    </div>
  );
};

export default EditForm;
